import { BarChart3, Calendar, ClipboardCheck, Phone, Trophy, Users } from 'lucide-react'
import { NavLink, Outlet } from 'react-router-dom'

const NAV = [
  { to: '/', label: 'Home', icon: BarChart3, end: true },
  { to: '/leaderboard', label: 'Leaderboard', icon: Trophy, end: false },
  { to: '/calls', label: 'Calls', icon: Phone, end: false },
  { to: '/agents', label: 'Agents', icon: Users, end: false },
  { to: '/appointments', label: 'Appointments', icon: Calendar, end: false },
  { to: '/coach-scorecard', label: 'Coach', icon: ClipboardCheck, end: false },
]

export function Layout() {
  return (
    <div className="flex h-screen flex-col bg-slate-950 text-slate-100">
      <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-6 px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 rounded-md bg-gradient-to-br from-indigo-500 to-fuchsia-500" />
            <span className="text-sm font-semibold tracking-wide">killacoach</span>
          </div>
          <nav className="flex items-center gap-1 text-sm">
            {NAV.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 rounded-md px-3 py-1.5 transition-colors ${
                    isActive
                      ? 'bg-slate-800 text-white'
                      : 'text-slate-400 hover:bg-slate-800/60 hover:text-slate-200'
                  }`
                }
              >
                <Icon className="h-3.5 w-3.5" />
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto text-xs text-slate-500">port 8400</div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto scrollbar-thin">
        <div className="mx-auto max-w-7xl px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
